  var Question = Chaplin.Model.extend({
    constructor: function() {
      Backbone.Model.apply(this, arguments);

      if(this.get('shuffle')) {
        this._shuffleAnswers();
      }
    },

    answersForDisplay: function(callback) {
      var A_char_code = 'A'.charCodeAt(0);
      this.get('answers').each(function(answer, idx) {
        var obj = {
          letter: String.fromCharCode(A_char_code + idx),
          text: answer.get('text')
        };
        if(callback) {
          callback(obj);
        }
        return obj;
      });
    },

    _shuffleAnswers: function() {
      // Fisher-Yates shuffle algo
      var answers = this.get('answers');
      var rand_idx, tempVal;
      var current_index = answers.length;
      while(current_index !== 0) {
        rand_idx = Math.floor(Math.random() * current_index);
        current_index -= 1;

        tempVal = answers[rand_idx];
        answers[rand_idx] = answers[current_index];
        answers[current_index] = tempVal;
      }
      this.set('answers', answers);
    }
  });

  _.extend(EF.Models.Assessments, {
    Question: Question
  });
